export type PaymentMethodMessages = {
  cardOption: string;
  boletoOption: string;
  pixOption: string;
};

export const PAYMENT_METHOD_MESSAGES: PaymentMethodMessages = {
  cardOption: "Cartão de Crédito/Débito",
  boletoOption: "Boleto Bancário",
  pixOption: "PIX",
};
